import React, { Component } from 'react';
import './NoTableData.scss';

export default class NoTableData extends Component {
  render() {

    return (
      <div className="no-data-container">
        <p className="big-question">?</p>
        <p className="no-data-message">No data matches<br />these parameters</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NoTableData/NoTableData.jsx